import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/style.css'

createApp(App).mount('#app')
